import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { observable: String }

  connect() {
    const observable = document.querySelector(this.observableValue)
      this.toggleDisabled(!observable)
    if (!observable) return


    this.observer = new MutationObserver(() => {
      this.toggleDisabled(observable.children.length === 0)
    })
    this.observer.observe(observable, { childList: true })
  }

  toggleDisabled(flag) {
    this.element.classList.toggle('disabled', flag)
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
